<template>
  <div class="wrapper">
    <Button label="Lägg till ny rad" icon="pi pi-plus" @click="addNewRow" />
    <Dialog :visible.sync="dialogVisible" :style="{width: '400px'}" header="Ny orderrad" :modal="true">
      <div class="p-cardialog-content">
        <div class="p-grid p-fluid">
              <div class="p-col-4"><label for="state">Status</label></div>
              <div class="p-col-8">
               <Dropdown v-model="orderRow.state" optionValue="name" :options="dropDownStates" optionLabel="name" placeholder="Välj Status" />
              </div>
              <!--<div class="p-col-4"><label for="state">Starttid</label></div>
              <div class="p-col-8">
                <Calendar id="startTime" v-model="orderRow.startTime" :showTime="true" hourFormat="24" :locale="sv" dateFormat="yy-mm-dd" />
              </div>
              <div class="p-col-4"><label for="state">Sluttid</label></div>
              <div class="p-col-8">
                  <Calendar id="startTime" v-model="orderRow.endTime" :showTime="true" hourFormat="24" :locale="sv" dateFormat="yy-mm-dd" />
              </div>-->
              <div class="p-col-4"><label for="state">Chaufför</label></div>
              <div class="p-col-8">
                <Dropdown v-model="orderRow.driverId" optionValue="id" :options="drivers" optionLabel="name" placeholder="Välj chaufför" @change="driverChange($event.value)" />
              </div>
              <!--<div class="p-col-4"><label for="state">Lastbil</label></div>
              <div class="p-col-8">
                <Dropdown v-model="orderRow.truckId" optionValue="id" :options="trucks" optionLabel="name" placeholder="Välj lastbil" />
              </div>-->
              <div class="p-col-4"><label for="state">Artikel</label></div>
              <div class="p-col-8">
                <Dropdown v-model="orderRow.articleId" optionValue="id" :options="articles" optionLabel="name" placeholder="Välj artikel" @change="articleChange($event.value)" />
              </div>
        </div>
      </div>
       <template #footer>
        <Button label="Spara" icon="pi pi-check" :disabled="orderRow.state.length === 0 || orderRow.driverId.length === 0 || orderRow.truckId.length === 0 || orderRow.articleId.length === 0" @click="saveOrderRow" class="p-button-success" />
    </template>
    </Dialog>
  </div>
</template>
<script>
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import Calendar from 'primevue/calendar'
import uuidv4 from 'uuid/v4'
import { bus } from '../../main'
export default {
  components: {
    Button,
    Dialog,
    InputText,
    Dropdown,
    Calendar,
    bus
  },
  data () {
    return {
      dialogVisible: false,
      orderRow: {actions: [], articleId: '', articleName: '', driverId: '', driverName: '', endTime: '', id: uuidv4(), loadedAmount: '', loadedEndTime: '', loadedStartTime: '', startTime: '', state: '', truckId: this.$props.truck.id, truckName: this.$props.truck.name},
      dropDownStates: [
        {name: 'Utförs', value: 'Utförs'},
        {name: 'Avslutad', value: 'Avslutad'}
      ],
      sv: {
        firstDayOfWeek: 1,
        dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
        dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
        dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
        monthNames: [ 'Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December' ],
        monthNamesShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec' ],
        today: 'Idag',
        clear: 'Rensa',
        dateFormat: 'yy-mm-dd',
        weekHeader: 'vk'
      },
      drivers: [],
      articles: []
    }
  },
  mounted () {
    this.getDrivers()
    this.getArticles()
  },
  props: {
    truck: Object
  },
  watch: {
    truck: function (newVal, oldVal) {
      this.$props.truck = newVal
    }
  },
  methods: {
    addNewRow () {
      console.log('test')
      this.dialogVisible = true
    },
    saveOrderRow () {
      this.dialogVisible = false
      bus.$emit('addedOrderRow', this.orderRow)
      this.orderRow = {actions: [], articleId: '', articleName: '', driverId: '', driverName: '', endTime: '', id: uuidv4(), loadedAmount: '', loadedEndTime: '', loadedStartTime: '', startTime: '', state: '', truckId: this.$props.truck.id, truckName: this.$props.truck.name}
    },
    driverChange (id) {
      let selectedDriver = this.drivers.find(x => x.id === id)
      this.orderRow.driverName = selectedDriver.name
    },
    articleChange (id) {
      let selectedArticle = this.articles.find(x => x.id === id)
      this.orderRow.articleName = selectedArticle.name
    },
    getDrivers () {
      this.$http
        .get('/api/users/drivers')
        .then(response => {
          var users = response.data
          for (var i = 0; i < users.length; i++) {
            this.drivers.push({'id': users[i].id, 'name': users[i].firstName + ' ' + users[i].lastName})
          }
        })
        .catch(error => console.log(error))
    },
    getArticles () {
      this.$http
        .get('/api/objectdatas/objectdescriptionid/17')
        .then(response => {
          var articles = response.data
          for (var i = 0; i < articles.length; i++) {
            this.articles.push({'id': articles[i].data.articleId, 'name': articles[i].data.name})
          }
        })
        .catch(error => console.log(error))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Activities/CreateNewOrderRow.vue